import {Component, computed, EventEmitter, inject, Input, OnInit, Output, Signal} from '@angular/core';
import {ContentStackLoadingStatus} from '@usana/ux/cms';
import {BaseComponent} from "../../base.component";
import {LoggerService} from "../../common/logger.service";
import {SessionService} from "../../common/session.service";
import {UserService} from "../../common/user.service";
import {IProduct, IProductGroup} from "../product-models";

@Component({
  selector: 'pdp-cms',
  templateUrl: './pdp-cms.component.html',
  styleUrls: ['./pdp-cms.component.scss'],
  standalone: false
})
export class PdpCmsComponent extends BaseComponent implements OnInit {
    private sessionService = inject(SessionService);

    productNumber: string;

    // Derived readiness; require both a locale and a valid marketProductId
    readonly cmsReady = computed(() => {
        return !!this.product && this.product.marketProductId > 0;
    });

    // Bubble CMS loading status up to parent component
    @Output() readonly cmsStatusChange = new EventEmitter<ContentStackLoadingStatus>();

    // passed from parent ProductComponent
    @Input() product?: IProduct;
    @Input() productGroup?: IProductGroup;

    constructor() {
        super(inject(UserService), inject(LoggerService));
    }

    async ngOnInit() {
        this.setProductNumber(this.product.usanaId);
    }

    setProductNumber(usanaId: string) {
        if((usanaId.match(new RegExp("\\.", 'g')) || []).length > 1) {
            //if id has more than 1 "." (oola and rise) we will just use the whole thing
            this.productNumber = usanaId;
        } else if (usanaId.indexOf('.') > -1) {
            this.productNumber = usanaId.split('.')[0];
        } else {
            this.productNumber = usanaId.substring(0, 3);
        }
    }

    onStatusChanged(event: ContentStackLoadingStatus) {
        this.log.debug("Bubble up cms status change event", event);
        this.cmsStatusChange.emit(event);
    }
}

